export { default as loaderJson } from "./lottie-files/loader.json";
export { default as loaderTitleJson } from "./lottie-files/loader-title.json";
//# sourceMappingURL=index.js.map